import { render, staticRenderFns } from "./MainOrder.vue?vue&type=template&id=e53a95b2&scoped=true&"
import script from "./MainOrder.vue?vue&type=script&lang=ts&"
export * from "./MainOrder.vue?vue&type=script&lang=ts&"
import style0 from "./MainOrder.vue?vue&type=style&index=0&id=e53a95b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53a95b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/NVME/projects/vbimex/client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VLayout})
